import Editor from '@monaco-editor/react';
import styled from 'styled-components/macro';

export const DisabledCodeEditor = styled(Editor)`
  .cursor {
    visibility: hidden !important;
  }
`;

DisabledCodeEditor.defaultProps = {
  options: {
    minimap: { enabled: false },
    autoClosingBrackets: 'never',
    readOnly: true,
  },
};
